<template>
  <va-modal
    
    size="small"
    v-model="loading"
    hideDefaultActions
    noOutsideDismiss
  >
  <semipolar-spinner
          :animation-duration="5000"
          :size="100"
          :color="fcolor"
        />
  </va-modal>
</template>

<script>
import { SemipolarSpinner } from "epic-spinners";

export default {
  props: ["loading","color"],
  computed:{
    fcolor(){
      return this.color==undefined? '#719BAE' : this.color;
    }
  },
  components: {
    SemipolarSpinner
  }
};
</script>
